<template>
  <div id="app">
        <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont"> {{ $t('Current-Account-Trial-Balance') }}</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-text-field flat="" solo-inverted="" hide-details v-model="search3" :label="$t('Search')" append-icon="search"></v-text-field>
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()" v-if="PB=='TRY'">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>


            </v-toolbar>
          </v-flex>
          <v-container fluid>
            <v-layout row wrap>


              <v-flex xs12 sm6 md4 style="padding-right:2px;padding-bottom:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">cached</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ $t('Total-Debit-v2') }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ toplamCariBorc | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ $t('Credit-Total') }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ toplamCariAlacak | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold"> {{ $t('Current-Payable') }} / {{ $t('Credit') }}</span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>


              <v-flex xs12 sm6 md4 style="padding-right:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">layers</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ $t('Total-Debit-v2') }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ toplamGenelBorc | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ $t('Credit-Total') }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  : {{ toplamGenelAlacak | moneyformat }}{{getparabirimi()}}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold"> {{$t('Grand-Total')}} </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>

              <v-flex xs12 sm6 md4 style="padding-right:2px;">
                <v-card color="#1E88E5" class="white--text">
                  <v-layout>
                    <v-flex xs2 sm2 md2>
                      <v-layout align-center="" justify-center="" fill-height="">
                        <v-icon color="white" large="">business_center</v-icon>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm10 md10>

                      <v-card-title primary-title="">
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">

                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">
                                  {{ toplamBakiye | bakiyekontrolsimgeli }}
                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout>
                            <v-flex xs12 sm4 md4>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">

                                </span>
                              </v-list-tile-title>
                            </v-flex>
                            <v-flex xs12 sm9 md8>
                              <v-list-tile-title>
                                <span class="subheading font-weight-">

                                </span>
                              </v-list-tile-title>
                            </v-flex>
                          </v-layout>
                        </v-flex>


                      </v-card-title>

                    </v-flex>
                  </v-layout>
                  <v-divider light></v-divider>
                  <v-card-actions class="pa-3">
                    <span class="subheading font-weight-bold"> {{ $t('General-Balance') }} </span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-flex>

            </v-layout>
          </v-container>


          <v-container fluid>
            <v-card color="grey lighten-5" flat>
              <v-form ref="formtarih" v-model="valid" lazy-validation>

                <v-layout row wrap>
                  <v-flex xs12 sm6 md2>
                    <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false" :rules="[v => !!v || $t('Please-select-a-date')]"
                      v-bind:defaultvalue="'ok'" v-bind:value="date" v-model="date"></tarihcomp>

                  </v-flex>

                  <v-flex xs12 sm6 md2>
                    <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false" :rules="[v => !!v || $t('Please-select-a-date')]"
                      v-bind:defaultvalue="'ok'" v-bind:value="date2" v-model="date2"></tarihcomp>
                  </v-flex>


                  <v-flex>
                    <v-layout align-center="">


                        <v-btn color="info" v-if="load1" @click="getList()" fab small="" dark>
                          <v-icon>search</v-icon>
                        </v-btn>

                              <v-progress-circular v-if="!load1" indeterminate :width="4" color="blue"></v-progress-circular>


                     <v-badge color="white"  :overlap="true">
                                                <template v-slot:badge>
                                                    <v-icon v-if="filtrevarmi" large color="green">
                                                    check_circle_outline                                                    
                                                    </v-icon>
                                                </template>

                                                <v-btn small="" @mouseenter="tooltip = true"
                                                    @mouseleave="tooltip = false" ref="fab" @click="filtrele()"
                                                    color="info" fab dark>
                                                    <v-icon>filter_list</v-icon>
                                                </v-btn>
                                                 <v-tooltip bottom="" :activator="el" v-model="tooltip">
                                                <span>{{$t('Add-Search-Filter')}}</span>
                                            </v-tooltip>



                                            </v-badge>
                    </v-layout>
                  </v-flex>




                  <v-dialog v-model="dialogfiltre" scrollable persistent="" max-width="500px">
                    <v-card color="grey lighten-5">

                      <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
                      <v-divider></v-divider>
                      <v-card-text style="height: 500px;">


                        <v-flex pa-1 xs12 sm12 md12>
                          <v-card class="white--text">
                            <v-card color="grey lighten-5" flat="">
                              <v-card-actions>
                         
                                <v-layout justify-space-between column>

                               <cariaracomp v-bind:etiket="$t('Accound-Code')" :loading="loading" v-bind:value="MizanCari.Cari.Kod" v-model="MizanCari.Cari.Kod"></cariaracomp>
                      
                               <cariaracomp v-bind:etiket="$t('Main-Account')" :loading="loading" v-bind:value="MizanCari.AnaHesap" v-model="MizanCari.AnaHesap"></cariaracomp>
                                  <v-select :items="hesapgurubu" v-model="MizanCari.HesapGrubu" hide-details="" :label="$t('Account-Group-Requested')"
                                    multiple item-text="Title" item-value="Kod" max-height="400"></v-select>

                                  <v-select :items="hesapgurubu" v-model="MizanCari.NoHesapGrubu" hide-details="" :label="$t('Account-Group-Not-Requested')"
                                    multiple item-text="Title" item-value="Kod" max-height="400" persistent-hint></v-select>
                                </v-layout>
                              </v-card-actions>
                            </v-card>
                          </v-card>
                          <v-layout justify-space-between column>
                            <br>
                            <v-card flat="" color="#9E9E9E">
                              <v-card-title>
                                <span class="subheading white--text font-weight-medium "> {{ $t('Options-v2') }} </span>
                              </v-card-title>
                            </v-card>
                            <v-checkbox :label="$t('Exclude-Zero-Balances')" hide-details="" v-model="MizanCari.BakiyeSifir"></v-checkbox>
                            <v-checkbox hide-details="" :label="$t('Only-Give-Payable-Balances')" v-model="MizanCari.SadeceBorcBakiye"></v-checkbox>
                            <v-checkbox hide-details="" :label="$t('Only-Give-Receivable-Balances')" v-model="MizanCari.SadeceAlacakBakiye"></v-checkbox>
                            <v-checkbox hide-details="" :label="$t('Fixed-Customer-Calculation')" v-model="MizanCari.PesinMusteri"></v-checkbox>
                            <v-checkbox hide-details="" :label="$t('Items-with-No-Movement-Current-Period')" v-model="MizanCari.CariDonemBakiyeli"></v-checkbox>
                            <v-checkbox hide-details="" :label="$t('Do-Not-Print-Current-Period')" v-model="MizanCari.CariDonemBasma"></v-checkbox>
                            <v-checkbox hide-details="" :label="$t('Show-Date-of-Last-Transaction-of-Current')" v-model="MizanCari.SonIslemTarih"></v-checkbox>
                            <v-checkbox hide-details="" :label="$t('Get-Trial-Balance-by-Invoice-Date')" v-model="MizanCari.FaturaTarih"></v-checkbox>
                            <v-checkbox hide-details="" :label="$t('Do-Not-Show-Records-without-Coper-Invoice')" v-model="MizanCari.CoperKayitGosterme"></v-checkbox>
                            <v-checkbox hide-details="" :label="$t('Do-Not-Show-Balances-below-1')" v-model="MizanCari.BakiyeBirAltiGosterme "></v-checkbox>



                            <v-checkbox hide-details="" :label="$t('All-Companies')" v-model="tumsirketler"></v-checkbox>
                          </v-layout>
                        </v-flex>

                      </v-card-text>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                        <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{$t('Apply-Filters')}}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>

                  <v-flex xs12 sm12>
                    <v-card flat>
                      <v-card-title>
                        <v-spacer></v-spacer>

                      </v-card-title>
                      <div class="cari-hesap-report-table">
                        <ReportTable
                          :headers="cariHesapReportHeaders"
                          :items="items"
                          storage-key="carihesap_columns"
                          :loading="progress"
                          :has-searched="items && items.length > 0"
                          :show-search="true"
                          :search-label="$t('Search')"
                          :show-frontend-export="true"
                          :export-title="$t('Current-Account-Trial-Balance')"
                          :export-meta-items="cariHesapExportMetaItems"
                          :export-summary-cards="cariHesapSummaryCards"
                          :rows-per-page-items="[50, 100, 250, 500, 1000]"
                        ></ReportTable>
                      </div>
                    </v-card>



                    <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
                      :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                      {{ text1 }}
                      <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
                    </v-snackbar>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card>
          </v-container>

        </v-layout>
      </v-card>
    </v-app>

  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"
  import tarihcomp from '../customcomp/tarihim'
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import cariaracomp from '@/components/app/customcomp/cariaracomp.vue'
  import ReportTable from '@/components/app/customcomp/ReportTable.vue'

  export default {
    data() {
      return {
        PB:'TRY',
         sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi:false,
        headers: [{
            text: this.$t('Accound-Code'),
            value: 'CariKod'
          },
          {
            text: this.$t('Account-Name'),
            value: 'CariUnvan'
          },
          {
            text: this.$t('Current-Payable'),
            value: 'CariBorc',
            align: 'right'

          },
          {
            text: this.$t('Current-Receivable'),
            value: 'CariAlacak',
            align: 'right'

          },
          {
            text: this.$t('General-Debit'),
            value: 'GenelBorc',
            align: 'right'

          },
          {
            text: this.$t('General-Credit'),
            value: 'GenelAlacak',
            align: 'right'

          },
          {
            text: this.$t('General-Balance'),
            value: 'GenelBakiye',
            align: 'right'

          }
        ],
        valid: true,
        MizanCari: {
          CariAlacak: '',
          CariBorc: '',
          CariKod: '',
          CariUnvan: '',
          GenelAlacak: '',
          GenelBakiye: '',
          GenelBorc: '',
          Sirketkodu: '',
          BaslangicTarih: '',
          BitisTarih: '',
          Cari: {
            SirketKodu: '',
            Kod: ''
          },
          AnaHesap: '',
          HesapGrubu: [],
          NoHesapGrubu: [],
          BakiyeSifir: false,
          SadeceBorcBakiye: false,
          SadeceAlacakBakiye: false,
          PesinMusteri: false,
          CariDonemBakiyeli: false,
          CariDonemBasma: false,
          SonIslemTarih: false,
          FaturaTarih: false,
          CoperKayitGosterme: false,
          BakiyeBirAltiGosterme:false
        },
        toplamBakiye: 0,
        toplamCariAlacak: 0,
        toplamCariBorc: 0,
        toplamGenelAlacak: 0,
        toplamGenelBorc: 0,
        toplamRisk: 0,
        StartDate: null,
        EndDate: null,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        date2yedek: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        loading1: false,
        search3: '',
        renk: 'white',
        renk1: 'info',
        items: [],
        load: false,
        load1: true,
        butondurum: true,
        hesapkodu: [],
        anahesap: [],
        hesapgurubu: [],
        e6: [],
        progress: false,
        tumsirketler: false,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        search: '',
        search1: '',
        cariKod: '',
        tooltip: false,
        el: null,

        dictionary: {
          custom: {

            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },

        filtre: {
          a: '',
          b: '',
          c: ''
        },
        dialogfiltre: false
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    components: {
      tarihcomp,
      yetkidialog,
      cariaracomp,
      ReportTable
    },
    mounted() {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.PB=credentials.ParaBirimi
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el
        this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              let url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              let url = '#/'
              window.open(url, '_self')
            }
          }

        });

      }


    },

    computed: {
cariHesapReportHeaders() {
        return [
          { text: this.$t('Accound-Code'), value: 'CariKod', visible: true, sortable: true, type: 'text', align: 'left', width: '160px' },
          { text: this.$t('Account-Name'), value: 'CariUnvan', visible: true, sortable: true, type: 'text', align: 'left', width: '280px' },
          { text: this.$t('Current-Payable'), value: 'CariBorc', visible: true, sortable: true, type: 'money', align: 'right', width: '160px' },
          { text: this.$t('Current-Receivable'), value: 'CariAlacak', visible: true, sortable: true, type: 'money', align: 'right', width: '160px' },
          { text: this.$t('General-Debit'), value: 'GenelBorc', visible: true, sortable: true, type: 'money', align: 'right', width: '160px' },
          { text: this.$t('General-Credit'), value: 'GenelAlacak', visible: true, sortable: true, type: 'money', align: 'right', width: '160px' },
          { text: this.$t('General-Balance'), value: 'GenelBakiye', visible: true, sortable: true, type: 'balance', align: 'right', width: '170px' }
        ]
      },

      cariHesapExportMetaItems() {
        return [
          { label: this.$t('Starting-Date'), value: this.date, type: 'date' },
          { label: this.$t('Finishing-Date'), value: this.date2, type: 'date' },
          { label: this.$t('Accound-Code'), value: this.MizanCari && this.MizanCari.Cari ? this.MizanCari.Cari.Kod : '' },
          { label: this.$t('Main-Account'), value: this.MizanCari ? this.MizanCari.AnaHesap : '' },
          { label: this.$t('Account-Group-Requested'), value: Array.isArray(this.MizanCari.HesapGrubu) ? this.MizanCari.HesapGrubu.join(', ') : '' },
          { label: this.$t('Account-Group-Not-Requested'), value: Array.isArray(this.MizanCari.NoHesapGrubu) ? this.MizanCari.NoHesapGrubu.join(', ') : '' },
          { label: this.$t('All-Companies'), value: this.tumsirketler === true ? 'Evet' : 'Hayır' }
        ]
      },

      cariHesapSummaryCards() {
        return [
          {
            title: this.$t('Current-Payable') + ' / ' + this.$t('Credit'),
            items: [
              { label: this.$t('Total-Debit-v2'), value: this.toplamCariBorc, type: 'money' },
              { label: this.$t('Credit-Total'), value: this.toplamCariAlacak, type: 'money' }
            ]
          },
          {
            title: this.$t('Grand-Total'),
            items: [
              { label: this.$t('Total-Debit-v2'), value: this.toplamGenelBorc, type: 'money' },
              { label: this.$t('Credit-Total'), value: this.toplamGenelAlacak, type: 'money' }
            ]
          },
          {
            title: this.$t('General-Balance'),
            items: [
              { label: this.$t('General-Balance'), value: this.toplamBakiye, type: 'balance' }
            ]
          }
        ]
      }
    },

    watch: {
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },
      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      },
      bakiyekontrolsimgeli: function (m) {
        return helpers.bakiyekontrolsimgeli(m);
      }
    },
    methods: {
            getparabirimi() {
        return helpers.getparabirimi()
      },
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal
    },
  }

  function getList() {

    if (this.$refs.formtarih.validate()) {

      var bastarih = new Date(this.date)
      var bittarih = new Date(this.date2)

      if (bastarih <= bittarih) {


        this.progress = true
        this.toplamBakiye = 0
        this.toplamCariAlacak = 0
        this.toplamCariBorc = 0
        this.toplamGenelAlacak = 0
        this.toplamGenelBorc = 0
        this.load = true
        this.load1 = false

        if (this.tumsirketler === true) {
          this.MizanCari.Sirketkodu = '0'
        } else {
          var credentials = JSON.parse(window.localStorage.getItem('credentials'));
          this.MizanCari.Sirketkodu = credentials.SirketKodu
        }

        this.MizanCari.BaslangicTarih = this.date
        this.MizanCari.BitisTarih = this.date2

        var params = this.MizanCari

        this.$http.post(auth.API_URL + 'api/TrialBalance/WithCurrent', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.items = response.body.List
          this.toplamBakiye = response.body.ToplamBakiye
          this.toplamCariAlacak = response.body.ToplamCariAlacak
          this.toplamCariBorc = response.body.ToplamCariBorc
          this.toplamGenelAlacak = response.body.ToplamGenelAlacak
          this.toplamGenelBorc = response.body.ToplamGenelBorc


          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true

          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true

          }
        })

      } else {
        this.text1 = this.$t('start-date-cannot-greater-than-end-date')
        this.snackbar = true
      }
    }
  }

  function getListHtml() {

    this.load = true
    this.load1 = false
    if (this.tumsirketler === true) {
      this.MizanCari.Sirketkodu = '0'
    } else {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      this.MizanCari.Sirketkodu = credentials.SirketKodu
    }
    var lang = localStorage.getItem('lang')
    this.MizanCari.Cari.SirketKodu = this.MizanCari.Sirketkodu
    this.MizanCari.BaslangicTarih = this.date
    this.MizanCari.BitisTarih = this.date2
    var params = this.MizanCari
    this.$http.post(auth.API_URL + 'api/TrialBalance/WithCurrentHtmlReport', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

          if (lang=='en')
          {
            // response.bodyText=response.bodyText.toString().replaceAll(" B"," D");
            // response.bodyText=response.bodyText.toString().replaceAll(" A"," C");
            var bodyhtml=helpers.getTranslatedHtml(response.bodyText);
             bodyhtml=bodyhtml.toString().replace('<title> CARİ HESAP MİZANI </title>','<title> CURRENT ACCOUNT TRIAL BALANCE </title>');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>CARİ HESAP MİZANI</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>CURRENT ACCOUNT TRIAL BALANCE</font>")

            
             response.bodyText=bodyhtml;
             
          }
      this.load = false
      this.load1 = true
      var blob = new Blob([response.bodyText], {
        type: 'application/html'
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = this.$t('TrialBalance') + ".html";
      link.click();
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.load = false
        this.load1 = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.load = false
        this.load1 = true
      }
    })
  }


  function getListExcel() {

    this.load = true
    this.load1 = false

    if (this.tumsirketler === true) {
      this.MizanCari.Sirketkodu = '0'
    } else {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      this.MizanCari.Sirketkodu = credentials.SirketKodu
    }

    this.MizanCari.BaslangicTarih = this.date
    this.MizanCari.BitisTarih = this.date2

    var params = this.MizanCari
    this.$http.post(auth.API_URL + 'api/TrialBalance/WithCurrentExcelReport', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      },
      responseType: "arraybuffer"
    }).then((response) => {
      this.load = false
      this.load1 = true
      var blob = new Blob([response.data], {
        type: 'application/xlsx'
      });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = this.$t('TrialBalance') + ".xlsx";
      link.click();

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.load = false
        this.load1 = true

      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.load = false
        this.load1 = true

      }
    })
  }



  function beforeMount() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.toplamBakiye = 0
    this.toplamCariAlacak = 0
    this.toplamCariBorc = 0
    this.toplamGenelAlacak = 0
    this.toplamGenelBorc = 0
    this.toplamRisk = 0

    this.date = helpers.getDateNow()
    this.date2 = helpers.getDateNow()
    this.MizanCari.BaslangicTarih = this.date
    this.MizanCari.BitisTarih = this.date2
    this.MizanCari.Sirketkodu = credentials.Sirketkodu


    var params3 = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params3, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgurubu = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

  }

  function filtrele() {
    this.dialogfiltre = true


  }

  function filtrekayit() {
    this.filtrevarmi=true
    this.dialogfiltre = false
    this.getList();
  }

  function filtreiptal() {
  this.filtrevarmi=false
    this.dialogfiltre = false
    this.MizanCari.Cari.Kod = null,
      this.MizanCari.Cari.Sirketkodu = null,
      this.MizanCari.AnaHesap = '',
      this.MizanCari.HesapGrubu = [],
      this.MizanCari.NoHesapGrubu = [],
      this.MizanCari.BakiyeSifir = false,
      this.MizanCari.SadeceBorcBakiye = false,
      this.MizanCari.SadeceAlacakBakiye = false,
      this.MizanCari.PesinMusteri = false,
      this.MizanCari.CariDonemBakiyeli = false,
      this.MizanCari.CariDonemBasma = false,
      this.MizanCari.SonIslemTarih = false,
      this.MizanCari.FaturaTarih = false,
      this.MizanCari.CoperKayitGosterme = false
    this.tumsirketler = false
  }
</script>

<style scoped>
.cari-hesap-report-table { width: 100%; }
.cari-hesap-report-table > * { width: 100%; }
</style>